import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { ViewFunnelPromotion } from './ViewFunnelPromotion';
import { ViewPortalPromotion } from './ViewPortalPromotion';
import { Promotion, PromotionSurface } from './types';
import { axios } from '../api';

export const ViewPromotion = () => {
  const { promotionId } = useParams<{ promotionId: string }>();
  const [promotionData, setPromotionData] = useState<Promotion>();
  const [loading, setLoading] = useState(true);

  const fetchData = useCallback(() => {
    if (!promotionId) {
      setLoading(false);
      return;
    }

    axios
      .get(`promotions/${promotionId}`)
      .then((response) => {
        setPromotionData(response.data);
        setLoading(false);
      })
      .catch((error) => console.error('Error:', error));
  }, [promotionId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!promotionData) {
    return <div>Promotion not found</div>;
  }

  if (promotionData.promotion_surface === PromotionSurface.PORTAL) {
    return <ViewPortalPromotion promotionData={promotionData} onRefresh={fetchData} />;
  }

  return <ViewFunnelPromotion promotionData={promotionData} onRefresh={fetchData} />;
};
